import { PasswordIcon } from '@phosphor-icons/react';
import type { ComponentPropsMap } from '@/components/form/form-input-wrapper';
import type { UsersChangePasswordRequest } from '@/services/users';

type DynamicField<T = string> = {
  [K in keyof ComponentPropsMap]: {
    name: T;
    type: K;
    label?: string;
    inputProps: ComponentPropsMap[K];
    span?: number;
  };
}[keyof ComponentPropsMap];

export const changePasswordSchema: DynamicField<keyof UsersChangePasswordRequest>[] = [
  {
    name: 'old_password',
    label: 'Kata Sandi Lama',
    type: 'password',
    inputProps: {
      placeholder: 'Masukkan kata sandi lama anda',
      leftSection: <PasswordIcon />,
    },
  },
  {
    name: 'new_password',
    label: 'Kata Sandi Baru',
    type: 'password',
    inputProps: {
      placeholder: 'Masukkan kata sandi baru anda',
      leftSection: <PasswordIcon />,
    },
  },
  {
    name: 'new_password_confirmation',
    label: 'Tulis Ulang Kata Sandi Baru',
    type: 'password',
    inputProps: {
      placeholder: 'Tulis ulang kata sandi baru anda',
      leftSection: <PasswordIcon />,
    },
  },
];
